import Div from 'src/components/atomic/atom/Div'
import Span from 'src/components/atomic/atom/Span'
import Button from 'src/components/atomic/atom/Button'
import { COLOR } from 'src/constants/colors'
import { RootState } from 'src/store/store'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { setCloseModal } from 'src/store/Reducer/common/modalSlice'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'

const DefaultModal = () => {
  const dispatch = useAppDispatch()
  const { text, type, className, cancelFunc, confirmFunc } = useAppSelector(
    (state: RootState) => state.modal,
  )
  const { t } = useTranslation()

  const handleCancelButton = () => {
    cancelFunc && cancelFunc()
    dispatch(setCloseModal())
  }

  const handleOkButton = () => {
    dispatch(setCloseModal())
    if (confirmFunc) {
      confirmFunc()
    }
  }
  console.log('Modal className:', className)
  return (
    <>
      <Span option={'small'} $margin={'0 0 24px 0'}>
        {text}
      </Span>
      <Div display={'flex'} $margin={'0 auto'} $gap={'16px'} $justify_content={'center'}>
        {type === 'confirm' && (
          <Button
            option={'modal_cancel'}
            $margin={'0'}
            $bgColor={COLOR.white}
            $border={`1px solid ${COLOR.brand};`}
            onClick={handleCancelButton}
            className={className === 'setting_sign_out' ? 'setting_sign_out_cancel' : ''}
          >
            <Span option={'small_bold'} color={COLOR.brand}>
              {t('BUTTON.CANCEL', { defaultValue: 'Cancel' })}
            </Span>
          </Button>
        )}
        <Button
          $bgColor={COLOR.brand}
          option={'modal_ok'}
          onClick={handleOkButton}
          $margin={'0'}
          className={className === 'setting_sign_out' ? 'setting_sign_out_ok' : ''}
        >
          <Span option={'small_bold'} color={COLOR.white}>
            {t('BUTTON.OK', { defaultValue: 'OK' })}
          </Span>
        </Button>
      </Div>
    </>
  )
}

export default DefaultModal
